import { render } from "./MemberCoverage.vue?vue&type=template&id=078d30c6&scoped=true"
import script from "./MemberCoverage.vue?vue&type=script&lang=js"
export * from "./MemberCoverage.vue?vue&type=script&lang=js"

import "./MemberCoverage.vue?vue&type=style&index=0&id=078d30c6&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078d30c6"]])

export default __exports__